import React from 'react'

const Experience = () => {
    return (
      <div className="exp">
        <div className="box">
          <h3>
            <a rel="noopener noreferrer" target="_blank" href="http://e-point.pl/">
              E-Point
            </a>
            <span>2020 - Obecnie</span>
          </h3>
            <span>na stanowisku Web Developera (PWA)</span>
            <p>Wykorzystuje tam takie technologie jak:</p>
            <ul>
                <li>ReactJS</li>
                <li>GraphQL</li>
                <li>Magento PWA Studio</li>
            </ul>
        </div>
        <div className="box">
          <h3>
            <a rel="noopener noreferrer" target="_blank" href="http://taat.pl/">
              TAAT Technologie Cyfrowe
            </a>
            <span>2018 - 2020</span>
          </h3>
            <span>na stanowisku Front-End Developera (z&nbsp;elementami&nbsp;backendu)</span>
            <p>Nauczyłem się tam między innymi:</p>
            <ul>
                <li>Semantyki kodu w <b>HTML5</b></li>
                <li>Technik pozycjonowania strony w <b>Google</b></li>
                <li>Preprocesora <b>SASS</b></li>
                <li>Bootstrapa</li>
                <li>Pracy z użyciem firmowego <b>CMS</b></li>
            </ul>
        </div>
      </div>
    );
}

export default Experience